import React from "react";
import { SITE } from "@/data/site";

export function LocationToggle({ value, onChange }) {
  return (
    <div className="space-y-2">
      <div className="text-xs uppercase tracking-[0.2em] text-brand-muted">Pobočka</div>
      <div className="grid grid-cols-2 gap-2" data-testid="reservation-location">
        {SITE.locations.map((l) => {
          const on = value === l.key;
          return (
            <button
              key={l.key}
              type="button"
              onClick={() => onChange(l.key)}
              aria-pressed={on}
              data-testid={`location-${l.key}`}
              className={`h-12 px-4 text-sm font-semibold border transition-all ${
                on
                  ? "bg-brand-accent text-black border-brand-accent"
                  : "bg-brand-bg text-white border-brand-border hover:border-white/40"
              }`}
            >
              {l.name.replace("Praha ", "")}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function VehicleSizeToggle({ value, onChange }) {
  return (
    <div className="space-y-2">
      <div className="text-xs uppercase tracking-[0.2em] text-brand-muted">Velikost vozu</div>
      <div className="grid grid-cols-2 gap-2" data-testid="reservation-vehicle-size">
        {SITE.vehicleSizes.map((v) => {
          const on = value === v.key;
          return (
            <button
              key={v.key}
              type="button"
              onClick={() => onChange(v.key)}
              aria-pressed={on}
              data-testid={`vehicle-${v.key}`}
              className={`h-12 px-3 text-sm font-semibold border transition-all flex flex-col items-center justify-center leading-tight ${
                on
                  ? "bg-brand-accent text-black border-brand-accent"
                  : "bg-brand-bg text-white border-brand-border hover:border-white/40"
              }`}
            >
              <span>{v.label}</span>
              <span className={`text-[10px] font-normal ${on ? "text-black/70" : "text-brand-muted"}`}>{v.hint}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
